// src/theme.js
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      50: "#e6f4ff",
      100: "#b9dbff",
      200: "#8bc3ff",
      300: "#5daaff",
      400: "#3092ff",
      500: "#1778e6", // color principal
      600: "#105cb4",
      700: "#0a4182",
      800: "#032551",
      900: "#000a21",
    },
    gray: {
      50: "#f9f9f9",
      100: "#f0f0f0",
      200: "#e5e5e5",
      300: "#d6d6d6",
      400: "#bdbdbd",
      500: "#999999",
      600: "#6e6e6e",
      700: "#4a4a4a",
      800: "#2a2a2a",
      900: "#111111",
    },
  },
  // Puedes personalizar tipografías, breakpoints, componentes, etc.
});

export default theme;
